const clipperAdminMenu = {
  Administración: [
    { type: 'link', iconKey: 'ajustes', label: 'Tarifas', to: '/tarifas' },
    {
      type: 'section',
      iconKey: 'lista',
      label: 'Geografía',
      items: [
        { label: 'Actualización de localidades', to: '/administracion/geografia/actualizacion-de-localidades', iconKey: 'lista' },
        { label: 'Provincias', to: '/administracion/geografia/provincias', iconKey: 'lista' },
        { label: 'Países', to: '/administracion/geografia/paises', iconKey: 'lista' },
        { label: 'Diccionario de localidades', to: '/administracion/geografia/diccionario-de-localidades', iconKey: 'lista' },
      ],
    },
    {
      type: 'section',
      iconKey: 'tesoreria',
      label: 'Bancos y Valores',
      items: [
        { label: 'Bancos', to: '/administracion/bancos-y-valores/bancos', iconKey: 'tesoreria' },
        { label: 'Conceptos bancarios', to: '/administracion/bancos-y-valores/conceptos-bancarios', iconKey: 'tesoreria' },
        { label: 'Retenciones y otros valores', to: '/administracion/bancos-y-valores/retenciones-y-otros-valores', iconKey: 'tesoreria' },
      ],
    },

  ],
};

export default clipperAdminMenu;
